import { render, staticRenderFns } from "./Kelrisks.vue?vue&type=template&id=2b42e216&"
import script from "./Kelrisks.vue?vue&type=script&lang=js&"
export * from "./Kelrisks.vue?vue&type=script&lang=js&"
import style0 from "./Kelrisks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports